import { useContext } from 'react'
import CustomizerContext from '../_helper/Customizer'

export const useLayout = () => {
	const { layoutURL } = useContext(CustomizerContext)
	return layoutURL
}
